import { Caption1 } from '@ui/Typography'

import { Box } from '@shared/components/Box'

import { CampaignProgressBar } from './CampaignProgressBar'

export const RebateCampaignProgressBar: React.FC<{ currentTier: number }> = ({ currentTier }) => {
  return (
    <Box flex direction='column' gap='x4' content='flex-end' align='flex-start' alignSelf='stretch'>
      <CampaignProgressBar currentTier={currentTier} />
      <Box flex align='center' alignSelf='stretch' position='relative' style={{ width: '320px' }}>
        <Box position='absolute' style={{ left: '1%' }}>
          <Caption1 color='text-med-em'>1</Caption1>
        </Box>
        <Box position='absolute' style={{ left: '48%' }}>
          <Caption1 color='text-med-em'>2</Caption1>
        </Box>
        <Box position='absolute' style={{ left: '98%' }}>
          <Caption1 color='text-med-em'>3</Caption1>
        </Box>
      </Box>
    </Box>
  )
}
